export default [
	{ id: 'ONE', question: 'L/L-2 Bends at the knees (not at the waist), keeps the natural curve of the back' },
	{ id: 'TWO', question: 'L/L-1 Gets close to the object, works within Power Zone.' },
	{ id: 'THREE', question: 'L/L-6 Tilts or slides the package to test for weight and/or shifting contents.' },
	{ id: 'FOUR', question: ' Uses hand to surface method when placing packages, bags, totes and freight' },
	{ id: 'FIVE', question: 'PP-16 Faces the flow of the packages at a 30 - 45 degree angle. ' },
	{ id: 'SIX', question: 'Uses load stand when working above shoulder height' }
]
